import Vue from 'vue'
import { mutationTypes } from './types'
import { Search } from '@/api'
import { extractErrors } from '@/data-extraction/users'
import { CONST } from '@/utils/constants'

export default {
  resetState: ({ commit }) => {
    commit(mutationTypes.RESET_STATE)
  },
  updateSearchResults: async ({ commit }, params = {}) => {
    const selectedFilters = { query: params.query, categories: params.category === 'All' ? CONST.SearchSettings.defaultFilter.categories : [params.category] }
    const unexpectedError = [ Vue.i18n.translate('default search results error') ]
    const defaultFilter = CONST.SearchSettings.defaultFilter
    // create filter overriding default values with user choosen values
    let filters = { ...defaultFilter, ...selectedFilters }
    commit(mutationTypes.GET_SEARCH_RESULTS_PENDING, params)
    try {
      const response = await Search.getSearchResults(filters)
      let allResults = []
      // build final array with loop becaue API response is fragmented
      response.data.Categories.forEach(categoryResult => {
        const results = categoryResult.Results.Results
        const category = categoryResult.Category
        commit(mutationTypes.DISTRIBUTE_CATEGORY_SUCCESS, { category, results })
        allResults.push(...results)
      })
      commit(mutationTypes.GET_SEARCH_RESULTS_SUCCESS, allResults)
      return allResults
    } catch (err) {
      const error = extractErrors.workspace(err) || unexpectedError
      commit(mutationTypes.GET_SEARCH_RESULTS_FAILURE, error)
      throw error
    }
  },
  goBackToRecentWorkspaces: ({ commit }) => {
    commit(mutationTypes.GO_BACK_TO_RECENT_WORKSPACES)
  }
}
